import React, { useRef } from 'react';
import { Edit2, MoreVertical, Trash } from 'lucide-react';
import PropTypes from 'prop-types';
import { Box, Card, Flex, Text } from 'rebass/styled-components';

import { Dropdown } from '../../../../molecules/dropdown';

export const NoteMenu = ({ onEdit, onDelete }) => {
  const ref = useRef(null);

  return (
    <Dropdown
      ref={ref}
      placement="left-start"
      trigger={
        <Flex
          alignItems="center"
          justifyContent="center"
          width="24px"
          height="24px"
          sx={{
            cursor: 'pointer',
            svg: {
              color: 'neutral.400',
            },
          }}
        >
          <Box as={MoreVertical} size="16px" aria-hidden="true" />
        </Flex>
      }
    >
      <Card sx={{ width: '200px', py: '8px', borderRadius: '4px' }}>
        <Flex
          alignItems="center"
          px="8px"
          py="4px"
          sx={{
            gap: '8px',
            color: 'text.main',
            cursor: 'pointer',
            '&:hover': {
              color: 'text.dark',
            },
          }}
          onClick={(e) => {
            e.stopPropagation();
            ref.current.closeDropdown();
            onEdit();
          }}
        >
          <Box as={Edit2} size="16px" />
          <Text fontSize="14px" fontWeight="500" lineHeight="24px">
            Edit
          </Text>
        </Flex>
        <Box as="hr" variant="hr" />
        <Flex
          alignItems="center"
          px="8px"
          py="4px"
          sx={{
            gap: '8px',
            color: 'red.600',
            cursor: 'pointer',
            '&:hover': {
              color: 'red.700',
            },
          }}
          onClick={(e) => {
            e.stopPropagation();
            ref.current.closeDropdown();
            onDelete();
          }}
        >
          <Box as={Trash} size="16px" />
          <Text fontSize="14px" fontWeight="500" lineHeight="24px">
            Delete
          </Text>
        </Flex>
      </Card>
    </Dropdown>
  );
};

NoteMenu.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
